import { useEffect, useState, useContext } from 'react';
import { Box, CircularProgress } from '@material-ui/core';
import { Alert } from '@mui/material';
import DualChartAdvanced from '../../InstantAdvanced/DualChartAdvanced';
import UserContext from '../../../context/UserContext';
//Servicios
import { get_vars_Automate_byId } from '../../../services/plc_automate';
import { getInstantV2 } from '../../../services/meters';
import _cloneDeep from 'lodash/cloneDeep';
import { chekUrlPublic } from '../../DynamicDashboard/helpers';


function ContainerChartInstantAdvanced({ filter, auxHeight, ky, content }) {
  const [loading, setLoading] = useState(false);
  const { plan } = useContext(UserContext);
  const [errorMessage, setErrorMessage] = useState('Ocurrio un error al cargar los datos');
  const [instantData, setInstantData] = useState([]);
  const [tz, setTz] = useState('America/Argentina/Buenos_Aires');

  //Valida el timeZone
  useEffect(() => {
    setTz(plan?.info?.tz)
  }, [plan])

  useEffect(() => {
    const fetchInstantData = async () => {
      if (chekUrlPublic() && content) {
        const storage = (localStorage.getItem('PUBLIC'))
        const sections = JSON.parse(storage).sections?.DASHBOARDS_INSTANT
        let dataToRender = [];
        content.forEach((item, index) => {
          const firstKey = Object.keys(item[0].data)[0].toLocaleLowerCase();
          let variable = sections.find(item => item.fields === firstKey)

          const color =
            filter?.groups?.[1]?.dataSets?.[index]?.color || item[0]?.node?.color || '#3366CC';
          let data = {
            devices: [item[0]?.node],
            alias: item[0]?.node?.nombre,
            groupIndex: 0,
            granularity: 5,
            variable: variable?.key || firstKey,
            variableName: variable?.name || firstKey,
            data: item[0].data,
            color,
            base_unit: ''
          }
          dataToRender.push(data);
        })
        setInstantData(dataToRender);
      } else if (filter) {
        setLoading(true)
        try {
          let catalogoLocal = plan?.sections?.["DASHBOARDS_INSTANT"]?.filter(item => item.enabled) || [];
          let res = await get_vars_Automate_byId();
          if (res?.data?.sections?.VARIABLES) {
            let VARS_CATALOGO = [...catalogoLocal, ...res.data.sections.VARIABLES];
            await handleSubmit(filter, VARS_CATALOGO)
            setLoading(false);
          }
        }
        catch (error) {
        }
      }
    }
    fetchInstantData();
  }, [filter])

  const handleSubmit = async (filterAux, VARS_CATALOGO) => {
    if (filterAux) {
      let filter = _cloneDeep(filterAux)
      setErrorMessage('');
      let devices = [];
      const fetchPromises = [];
      //Remueve valores en null
      [filter.groups[1]].forEach((group, groupIndex) => {
        let range = filter?.range
        group.dataSets.forEach((dataset) => {
          let url = '';
          let selectedNodeId = dataset?.devices[0]?.id;
          let selectedTagId = dataset?.devices[0]?.label_id;
          let variable = VARS_CATALOGO?.find(item => item.key === dataset.variable);
          //Si el dataset es un automate.(solamente tendra un dispositivo cargado)
          if (dataset?.devices.length > 0) {
            if (dataset?.devices[0]?.automates.length > 0) {
              variable = VARS_CATALOGO?.find((item) => {
                if (item.group.key === dataset?.devices[0]?.automates[0]?.llave && item.key === dataset.variable) {
                  return item
                }
              });
            }
          }
          dataset.variableName = variable?.name
          dataset.granularity = parseInt(dataset?.granularity);

          //Es una variable personalizada se modifica la url
          if (variable?.client_var) {
            // filter=8499&filter=15531&vars=94E6868811B8+1,10&response_format=v2&from=1/2/2025&to=28/2/2025
            url += `filter=${selectedNodeId}`
            url += `&vars=${variable?.group?.key}`
            url += `+${variable?.key}`
            url += `&response_format=v2`;
            // Asigna rango
            url += `&range=${range}`
          }
          else {
            // Asigna dispositivo con etiqueta si se seleccionó
            url += `filter=${selectedNodeId}`;
            if (selectedTagId) {
              url += `+${selectedTagId}`;
              let nameDevice = `${dataset?.devices[0]?.nombre} ${dataset?.devices[0]?.label_nombre}`
              devices.push(nameDevice)
            }
            else {
              let nameDevice = `${dataset?.devices[0]?.nombre}`
              devices.push(nameDevice)
            }
            // Asigna variable
            url += `&fields=${variable.fields}`;
            // Asigna granularidad
            url += `&granularity=${parseInt(dataset?.granularity)}`;
            // Asigna rango
            url += `&range=${range}`
            url += `&response_format=v2`;
            // Asigna franja horaria
            url += dataset.timeslots ? `&timeslots=${dataset.timeslots}` : '';
            // Si selecciono variable por fase la asigna
            url += filter.showPhase ? `&showPhase=true` : '';
          }
          fetchPromises.push(
            fetchInstant(
              url,
              dataset,
              groupIndex,
            )
          );
        })
      });
      setLoading(true);
      try {
        const results = await Promise.all(fetchPromises);
        const successfulResults = results.filter(data => data !== null);
        const groupedArray = Object.values(
          successfulResults.reduce((acc, item) => {
            if (!acc[item.groupIndex]) {
              acc[item.groupIndex] = []; // Inicializa un nuevo grupo si no existe
            }
            acc[item.groupIndex].push(item); // Agrega el objeto al grupo correspondiente
            return acc;
          }, {})
        );

        setInstantData(groupedArray)
        if (successfulResults.length === 0) {
          // Todas las solicitudes fallaron
          setErrorMessage('Ha ocurrido un error');
          setInstantData([]);
        }
        else {
          // Mezclar los datos exitosos
          const mergedData = successfulResults.reduce((acc, data) => acc.concat(data), []);
          setInstantData(mergedData);
        }
      }
      catch (error) {
        console.error('Error al obtener datos:', error);
        setInstantData([]);
      }
      finally {
        setLoading(false);
      }
    }
  };

  const fetchInstant = async (
    url,
    dataset,
    groupIndex,
  ) => {
    //hace esto por cada dataset
    try {
      const res = await getInstantV2(url);
      if (res.data.error) {
        return []; // Retorna un array vacío si hay error
      } else {
        let data = res.data[0]?.data;
        let medidores = []
        if (res.data[0]?.medidores) {
          medidores = [...res.data[0]?.medidores]
        }
        let resData = {
          ...dataset,
          data,
          groupIndex,
          medidores
        }

        return resData;
      }
    }
    catch (error) {
      setInstantData([]);
      if (error.response) {
        if (error.response.status === 404) {
          setErrorMessage(
            `No se encontraron datos para el período ${dataset.alias}.`
          );
        } else {
          setErrorMessage(`El dataset ${dataset.alias} devolvió un error.`);
        }
      } else {
        setErrorMessage(`Ocurrió un error inesperado`);
      }
      return []; // Retorna un array vacío en caso de error
    }
  };

  return (
    <Box style={{ height: '100%' }}  >
      {loading ?
        <Box display='flex' justifyContent='center' mt={2}>
          <CircularProgress />
        </Box>
        :
        < >
          {instantData.length > 0 ?
            <DualChartAdvanced
              filter={filter}
              tz={tz}
              chartData={instantData}
              auxHeight={auxHeight}
              ky={ky}
              zoomBar={true}
            />
            :
            <Alert severity='error'>{errorMessage}</Alert>
          }
        </>
      }
    </Box>
  );
}
export default ContainerChartInstantAdvanced;
